var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v("Assignments")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.isLoading,"headers":_vm.headers,"items":_vm.tables,"items-per-page":5,"show-expand":"","item-key":"assignment_Start_Date"},scopedSlots:_vm._u([{key:"item.assignment_Start_Date",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDate(item.assignment_Start_Date))+"\n    ")]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('rates',{attrs:{"tables":item.rates}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }